import { ClickButtonInstruction } from '../ClickButtonInstruction'

export class ClickNewAddressInstruction extends ClickButtonInstruction {
  constructor ({ waitForNoLoaders, click }) {
    super({
      name: 'ClickNewAddress',
      waitForNoLoaders: waitForNoLoaders === undefined ? true : waitForNoLoaders,
      className: 'action action-show-popup',
      click: click === undefined ? true : click,
      isVisible: false
    })
  }
}
